import { types } from '../../types';

const setGetReplenishmentReportAction = (payload) => {
  return {
    type: types.report.SET_REPLENISHMENT_REPORT,
    payload,
  }
}

export {
  setGetReplenishmentReportAction as SetGetReplenishmentReportAction
}
